import { useState } from "react";

/**
 * Hidden honeypot input. Bots auto-fill every visible field, including this
 * one. The backend rejects the submission if `_hp` is non-empty.
 *
 * Usage:
 *   const [hp, HoneypotField] = useHoneypot();
 *   ...
 *   <form>
 *     <HoneypotField />
 *     ...
 *     onSubmit: api.post("/leads", { ...form, _hp: hp })
 *   </form>
 */
export function useHoneypot() {
  const [hp, setHp] = useState("");
  const Field = () => (
    <div aria-hidden="true" style={{ position: "absolute", left: "-10000px", top: "auto", width: "1px", height: "1px", overflow: "hidden" }}>
      <label>
        No completar este campo
        <input
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          value={hp}
          onChange={(e) => setHp(e.target.value)}
        />
      </label>
    </div>
  );
  return [hp, Field];
}
